import axiosInstance from "../axios/axiosInstance";
import ENV from "constants/env";

const cid = () => localStorage.getItem("companyId") || ENV.COMPANY_ID;

export const getCompany = async () => (await axiosInstance.get(`/companies/${cid()}`)).data;
export const updateCompany = async (payload) => (await axiosInstance.patch(`/companies/${cid()}`, payload)).data;
export const getCompanyBankAccounts = async () => (await axiosInstance.get(`/companies/${cid()}/bank-accounts`)).data;
export const createCompanyBankAccount = async (payload) => (await axiosInstance.post(`/companies/${cid()}/bank-accounts`, payload)).data;
export const getCompanyAchSettings = async () => { try { return (await axiosInstance.get(`/companies/${cid()}/ach-settings`)).data; } catch { return null; } };
export const deleteCompanyBankAccount = async (id) => (await axiosInstance.delete(`/companies/${cid()}/bank-accounts/${id}`)).data;
export const getSignatories = async () => (await axiosInstance.get(`/companies/${cid()}/signatories`)).data;
export const addSignatory = async (payload) => (await axiosInstance.post(`/companies/${cid()}/signatories`, payload)).data;

export const getYtdEntries = async () => (await axiosInstance.get(`/companies/${cid()}/ytd-entries`)).data;
export const createYtdEntry = async (payload) => (await axiosInstance.post(`/companies/${cid()}/ytd-entries`, payload)).data;

export const getCompanyDocuments = async (type) => {
    const url = type ? `/companies/${cid()}/documents?type=${type}` : `/companies/${cid()}/documents`;
    return (await axiosInstance.get(url)).data;
};
export const uploadCompanyDocument = async (formData) =>
    (await axiosInstance.post(`/companies/${cid()}/documents`, formData)).data;

export const deleteCompanyDocument = async (documentId) =>
    (await axiosInstance.delete(`/companies/${cid()}/documents/${documentId}`)).data;

// AccountNoot Integration
export const getAccountNootSettings = async () => {
    try { return (await axiosInstance.get(`/companies/${cid()}/accountnoot/settings`)).data; } catch { return null; }
};
export const saveAccountNootSettings = async (payload) =>
    (await axiosInstance.post(`/companies/${cid()}/accountnoot/settings`, payload)).data;
export const syncPayrollToAccountNoot = async (payrollId) =>
    (await axiosInstance.post(`/companies/${cid()}/accountnoot/sync/${payrollId}`)).data;
export const getAccountNootSyncStatus = async (payrollId) => {
    try { return (await axiosInstance.get(`/companies/${cid()}/accountnoot/sync-status/${payrollId}`)).data; } catch { return null; }
};
export const getAccountNootSyncLogs = async (limit = 20) => {
    try { return (await axiosInstance.get(`/companies/${cid()}/accountnoot/sync-logs?limit=${limit}`)).data; } catch { return []; }
};




